import { SecretValues } from "../types/KeyVault";
import apiClient from "../utils/apiClient";

export const getPortalSecretValue = async (): Promise<SecretValues> => {
    const response = await apiClient.get<SecretValues>(`/portaluser/secret-value`);
  return response.data;
};

